import {tracking_events} from '@utilities/track-abstract/track-abstract';

// Pinterest Tracking
if (!window.pintrk) {
    window.pintrk = function() {
        window.pintrk.queue.push(Array.prototype.slice.call(arguments))
    };
    window.pintrk.queue = [];
    window.pintrk.version = "3.0";
}

let tracking_started = false;

const sal_pintrk = {
    start_tracking: () => {
        if (tracking_started) {
            return;
        } else {
            tracking_started = true;
        }

        if (document.location.hostname.indexOf('pfleiderer.com') !== -1) {
            const src = 'https://s.pinimg.com/ct/core.js';

            const scriptTag = document.createElement('script');
            scriptTag.async = true;
            scriptTag.src = src;
            if (window.PFL_AUTHENTICATED && window.PFL_AUTH_PTRACK) {
                window.pintrk('load', '2613639226176', {em: window.PFL_AUTH_PTRACK});
            } else {
                window.pintrk('load', '2613639226176');
            }
            window.pintrk('page');

            // Always track page visit
            window.pintrk('track', 'pagevisit');

            document.body.appendChild(scriptTag);
        }
    },
    // eslint-disable-next-line no-unused-vars
    track_event: (event, payload) => {
        if (window.pintrk) {
            switch (event) {
            case tracking_events.AddToCart: // payload = { id, title, subtitle, subsubtitle }
                // Klick auf Add To Warenkorb
                window.pintrk('track', 'addtocart', {
                    value: 100,
                    order_quantity: 1,
                    currency: 'USD'
                });
                break;
            case tracking_events.ClickEmail: // payload = email
            case tracking_events.ClickPhone: // payload = number
                window.pintrk('track', 'custom', {
                    lead_type: 'Contact'
                });
                break;
            case tracking_events.AddToDealerRequest:
                window.pintrk('track', 'lead', {
                    lead_type: 'Newsletter'
                })
                break;
            case tracking_events.ClickLogin:
            case tracking_events.ClickRegister:
                window.pintrk('track', 'signup');
                break;
            case tracking_events.UrlContainsMoodboard:
                window.pintrk('track', 'user_defined_event_name', {
                    line_items: [{product_name: 'moodboard'}]
                });
                break;
            case tracking_events.UrlContainsWorkapp:
                window.pintrk('track', 'user_defined_event_name', {
                    line_items: [{product_name: 'workapp'}]
                });
                break;
            case tracking_events.UrlContainsWoodpro:
                window.pintrk('track', 'user_defined_event_name', {
                    line_items: [{product_name: 'woodpro'}]
                });
                break;
            }
        }
    }
};

export {sal_pintrk};
// End Pinterest Tracking
